import {
  BffHostConfigResponse,
  BffUnauthorizedCallHostConfigResponse,
} from 'APP/wsApi/wsAppApi/types/host_config/host_config_response_pb';

import { IHostConfig } from './configModel.types';

export function mapHostConfigResponse(response: BffHostConfigResponse): IHostConfig {
  return {
    hostName: response.hostName,
    bffUrl: response.hostRestUrl,
    wsApiUrl: response.hostSocketUrl,
    liveKitCallsUrl: response.hostCallSocketUrl,
    unauthorizedUrl: response.hostUnauthorizedCallUrl,
    supportEmail: response.supportEmail,
  };
}

export function mapUnauthorizedCallHostConfigResponse(
  response: BffUnauthorizedCallHostConfigResponse
): IHostConfig {
  return {
    hostName: '',
    bffUrl: '',
    wsApiUrl: '',
    liveKitCallsUrl: response.hostCallSocketUrl,
    unauthorizedUrl: response.hostUnauthorizedCallUrl,
    supportEmail: '',
  };
}
